import Vue from "vue";
import router from "@/router";
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  namespaced: true,
  state: {
    _loading: {
      getLog: false,
      getAccessLog: false,
      getAccountLog: false,
      getPositionTakingLog: false,
      getBetLimitLog: false,
      getCommissionLog: false,
      getTransactionLog: false,
      getMemberLog: false,
    },
    logStatusDesc: [
      { key: "OK", value: "OK" },
      { key: "invalidParameter", value: "Invalid Parameter" },
      { key: "systemError", value: "System unable to process your request" },
      { key: "spErrorMessage", value: "SP Message Error" },
      { key: "actionbyRequired", value: "Current User is required" },
      { key: "sessionTokenRequired", value: "Session Token is required" },
      { key: "pageIdRequired", value: "Page ID is required" },
      { key: "newPageIdRequired", value: "Page ID is required" },
      { key: "newPageNameRequired", value: "Page name is required" },
      { key: "targetPageIdRequired", value: "Target Page ID is required" },
      { key: "userIdRequired", value: "User ID is required" },
      { key: "passwordRequired", value: "Password is required" },
      { key: "userNameRequired", value: "Full Name is required" },
      { key: "passwordValidation", value: "Password must be 6-20 characters and a combination of number(s) and letter(s)" },
      { key: "targetRoleIdRequired", value: "Target Role ID is required" },
      { key: "roleIdRequired", value: "Role ID is required" },
      { key: "oldPasswordRequired", value: "Current Password is required" },
      { key: "userStatusRequired", value: "User Status is required" },
      { key: "newRoleIdRequired", value: "Role ID is required" },
      { key: "newRoleNameRequired", value: "Role Name is required" },
      { key: "startDateRequired", value: "Start Date is required" },
      { key: "endDateRequired", value: "End Date is required" },
      { key: "startDateIsGteEndDate", value: "Start Date is greater than End Date" },
      { key: "accountIdRequired", value: "Account ID is required" },
      { key: "invalidPageNumber", value: "Invalid Page Number" },
      { key: "invalidPageSize", value: "Invalid Page Size" },
      { key: "accountStatusRequired", value: "Account status is required" },
      { key: "parentIdRequired", value: "Parent ID is required" },
      { key: "companyIdRequired", value: "Company is required" },
      { key: "masterIdRequired", value: "Master ID is required" },
      { key: "invalidMode", value: "Invalid mode" },
      { key: "recipientIdRequired", value: "Recipient ID is required" },
      { key: "transferMethodRequired", value: "Transfer Method is required" },
      { key: "invalidTransferAmount", value: "Invalid Transfer Amount" },
      { key: "invalidHotline", value: "Invalid Hotline" },
      { key: "invalidPhone", value: "Invalid Phone" },
      { key: "invalidEmail", value: "Invalid Email" },
      { key: "invalidFacebook", value: "Invalid Facebook" },
      { key: "senderIdRequired", value: "Sender ID is required" },
      { key: "pageNumRequired", value: "Page Number is required" },
      { key: "pageSizeRequired", value: "Page Size is required" },
      { key: "fullNameLessLength", value: "Full Name must have at least 2 characters" },
      { key: "fullNameLessEqLength", value: "Full Name must be less or equal to 50 characters" },
      { key: "hotlineLessLength", value: "Hotline must have at least 9 numberic" },
      { key: "hotlineLessEqLength", value: "Hotline must be less or equal to 50 numberic" },
      { key: "phoneLessLength", value: "Phone must have at least 9 numberic" },
      { key: "phoneLessEqLength", value: "Phone must be less or equal to 50 numberic" },
      { key: "emailLessLength", value: "Email must have at least 2 characters" },
      { key: "emailLessEqLength", value: "Email must be less or equal to 255 characters" },
      { key: "facebookLessLength", value: "Facebook must have at least 2 characters" },
      { key: "facebookLessEqLength", value: "Facebook must be less or equal to 255 characters" },
      { key: "messageLessLength", value: "Message must have at least 2 characters" },
      { key: "messageLessEqLength", value: "Message must be less or equal to 510 characters" },
      { key: "referenceLessLength", value: "Reference must have at least 2 characters" },
      { key: "referenceLessEqLength", value: "Reference must be less or equal to 510 characters" },
      { key: "thisRoleExists", value: "This Role already exists" },
      { key: "thisRoleNotExists", value: "This Role is not exists" },
      { key: "thisRoleNotAllowDelete", value: "This Role is not allow to delete, it has been used" },
      { key: "thisPageExists", value: "This Page is already exists" },
      { key: "thisPageNotExists", value: "This Page is not exists" },
      { key: "thisPageNotAllowDelete", value: "This Page is not allow to delete, it has been used" },
      { key: "thisUserExists", value: "This User is already exists" },
      { key: "thisUserNotExists", value: "This User is not exists" },
      { key: "invalidPassword", value: "Invalid Username or Password" },
      { key: "invalidLogin", value: "Invalid Username or Password" },
      { key: "thisUserBlackListed", value: "Your account has been blacklisted" },
      { key: "thisUserInactive", value: "Your account has been inactive" },
      { key: "thisUserBlocked", value: "Your account has been blocked" },
      { key: "thisUserNotActive", value: "Your account has been not active" },
      { key: "invalidUser", value: "Invalid User!" },
      { key: "invalidToken", value: "Invalid Session!" },
      { key: "NoUserAccessRight", value: "Permission Denied!" },
      { key: "InvalidPageFunction", value: "Invalid Page Function" },
      { key: "thisFunctionExists", value: "This Function already exists" },
      { key: "thisFunctionNotExists", value: "This Function not exists" },
      { key: "thisFunctionNotAllowDelete", value: "This Function is not allowed to delete, it has been used" },
      { key: "unableSPProcess", value: "System unable to process your request" },
      { key: "thisAccountNotExists", value: "This account is not exists" },
      { key: "thisAccountExists", value: "This account is exists" },
      { key: "thisParentNotExists", value: "This Parent ID is not exists" },
      { key: "invalidParentType", value: "Invalid Parent Type" },
      { key: "permissionDenied", value: "Permission is denied" },
      { key: "thisSenderNotExists", value: "This Sender is not exists" },
      { key: "thisRecipientNotExists", value: "The Recipient is not exists" },
      { key: "invalidCurrencyCode", value: "Invalid Current Code" },
      { key: "invalidOutstandingBalance", value: "Invalid Outstanding Balance" },
      { key: "insuffientFund", value: "Insuffient Fund" },
      { key: "invalidAccountType", value: "Invalid Account Type" }
    ]
  },
  mutations: {
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    }
  },
  getters: {
    getlogDetailByKey: state => {
      return sKey =>
        state.logDetailKey.reduce((result, logDetailKey) => {
          if (logDetailKey.key === sKey) {
            result = logDetailKey.value;
          }
          return result;
        }, sKey);
    },
    getlogStatusDescByKey: state => {
      return sStatusDesc =>
        state.logStatusDesc.reduce((result, logStatusDesc) => {
          if (logStatusDesc.key === sStatusDesc) {
            result = logStatusDesc.value;
          }
          return result;
        }, sStatusDesc);
    }
  },
  actions: {
    getLog(context, payload) {
      const url = payload.url;
      const body = {
        action_by: this.state.user.login.login_id,
        account_id: this.state.user.account.account_id,
        profile_id: this.state.user.profile.profile_id,
        session_token: this.state.user.login.auth_token,
        client_ip: payload.client_ip,
        login_id: this.state.user.login.login_id,
        search_id: payload.search_id,
        // search_id: "",
        currency: this.state.user.account.currency,
        sort_key: payload.sort_key,
        sort_type: payload.sort_type,
        page_number: payload.page_number,
        page_size: payload.page_size,
        start_date: payload.start_date,
        end_date: payload.end_date
      };
      const feedback = {
        value: [],
        success: false,
        errorTag: errorTags.request.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("url" in payload)) {
          feedback.errorTag = errorTags.getLog.urlRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (!("targetId" in payload)) {
        //   feedback.errorTag = errorTags.getLog.targetIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (payload.url.length <= 0) {
          feedback.errorTag = errorTags.getLog.urlRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (payload.targetId.length <= 0) {
        //   feedback.errorTag = errorTags.getLog.targetIDRequired;
        //   reject(feedback);
        //   canRequest = false;
        // }

        if (this.state.user._loading.getLog == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getLog", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getLog", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == true;
                }
                feedback.errorTag = successResponse.body.statusdesc;

                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dt;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.request.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("user/delete", payload, { root: true });
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getLog", status: false });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getAccessLog(context, payload) {
      const url = config.accessLogUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          page_number: payload.page_number,
          page_size: payload.page_size,
          start_date: payload.start_date,
          end_date: payload.end_date
        },
        filters: {
          ipAddress: payload.ipAddress,
          browserAgent: payload.browserAgent,
          actionBy: payload.actionBy,
          targetId: payload.targetId,
          targetAction: payload.targetAction,
          sortkey: payload.sortkey,
          sorttype: payload.sorttype
        }
      };
      const feedback = {
        value: [],
        success: false,
        status: errorTags.request.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (this.state.user._loading.getAccessLog == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getAccessLog", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getAccessLog", status: false });
              if (successResponse) {
                if(successResponse.body.results) {
                  feedback.success = false;
                  feedback.status = successResponse.body.results[0].statusdesc;
                  if (feedback.status == errorTags.session.expired || feedback.errorTag == errorTags.session.invalidSession) {
                    context.commit("user/delete", payload, { root: true });
                    router.push("/expired");
                  }
                  reject(feedback);
                } else {
                  try {
                    feedback.success = true;
                    feedback.status = "";
                    feedback.value = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.request.failed;
                    reject(feedback);
                  }
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getAccessLog", status: false });
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTransactionLogList(context, payload) {
      const url = config.transactionLogListUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          page_number: payload.page_number,
          page_size: payload.page_size,
          start_date: payload.start_date,
          end_date: payload.end_date
        },
        filters: {
          ipAddress: payload.ipAddress,
          browserAgent: payload.browserAgent,
          actionBy: payload.actionBy,
          targetId: this.state.user.account.account_id,
          targetAction: payload.targetAction,
          sortkey: payload.sortkey,
          sorttype: payload.sorttype
        }
      };
      const feedback = {
        value: [],
        success: false,
        status: errorTags.request.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;
        if (this.state.user._loading.getTransactionLogList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        if (canRequest == true) {
          context.commit("loading", { action: "getTransactionLogList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getTransactionLogList", status: false });
              if (successResponse) {
                if(successResponse.body.results) {
                  feedback.success = false;
                  feedback.status = successResponse.body.results[0].statusdesc;

                  if (feedback.status == errorTags.session.invalidToken) {
                    router.push("/expired");
                  }
                  reject(feedback);
                } else {
                  try {
                    feedback.success = true;
                    feedback.status = "";
                    feedback.value = successResponse.body;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.request.failed;
                    reject(feedback);
                  }
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getTransactionLogList", status: false });
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberLog(context, user) {
      const url = config.getMemberLogUrl();
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          search_id: user.search_id,
          action_status: user.action_status,
          start_date: user.start_date,
          end_date: user.end_date,
          page_number: user.page_number,
          page_size: user.page_size,
          sort_key: user.sort_key,
          sort_type: user.sort_type
        }
      };
      const feedback = {
        data: [],
        success: false,
        errorTag: errorTags.getMemberLog.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_id" in body.auth)) {
          feedback.errorTag = errorTags.getMemberLog.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (body.auth.account_id.length <= 0) {
          feedback.errorTag = errorTags.getMemberLog.accountIDRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberLog == true) {
          feedback.errorTag = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getMemberLog",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMemberLog",
                status: false
              });
              if (successResponse) {
                if (typeof successResponse.body.success == "string") {
                  feedback.success = successResponse.body.success == "1";
                } else {
                  feedback.success = successResponse.body.success == true;
                }
                feedback.errorTag = successResponse.body.errorTag;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.data.memberLog;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.errorTag = errorTags.getMemberLog.failed;
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.errorTag == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/expired");
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMemberLog",
                status: false
              });
              feedback.errorTag = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    }
  }
};
